<template>
  <section class="section section--alt">
    <div class="container">
      <h2 class="guide-heading fade-in-up">ご利用ガイド</h2>
      <div class="row justify-content-center">
        <div class="col-lg-8 fade-in-up delay-1">
          <div class="guide-card">
            <table class="table table-borderless mb-0">
              <tbody>
                <tr>
                  <th>注文期限</th>
                  <td>前日17時まで（または当日の午前中）</td>
                </tr>
                <tr>
                  <th>キャンセル</th>
                  <td>期限以降のキャンセルは不可</td>
                </tr>
                <tr>
                  <th>価格</th>
                  <td>600円〜</td>
                </tr>
                <tr>
                  <th>アレルギー</th>
                  <td>アレルギー対応食の提供・確認は不可</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionGuide',
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables';
@import '@/assets/scss/mixins';

.guide-heading {
  font-size: $font-size-section-title;
  font-weight: 700;
  color: $color-primary;
  text-align: center;
  margin-bottom: 2rem;
}

.guide-card {
  background-color: #fff;
  border-radius: $border-radius-lg;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  padding: 2rem;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-2px);
  }

  @include media-down(768px) {
    padding: 1.25rem;
  }
}

.table {
  th {
    width: 130px;
    font-weight: 700;
    color: $color-text;
    padding: 0.75rem 1rem;
    vertical-align: top;
    white-space: nowrap;

    @include media-down(576px) {
      width: 100px;
      font-size: $font-size-small;
    }
  }

  td {
    color: $color-text-light;
    padding: 0.75rem 1rem;
    line-height: 1.8;

    @include media-down(576px) {
      font-size: $font-size-small;
    }
  }

  tr:not(:last-child) {
    border-bottom: 1px solid #eee;
  }
}
</style>
